import { safeCallSegment } from '../helpers';

export function trackAddComment(boxId: string, mentions: readonly string[]): void {
  safeCallSegment(() => {
    analytics.track('Add Comment', {
      boxId,
      mentions
    });
  });
}
